export default "__VITE_ASSET__8byRiVPc__"